export const REGULAR = 'regular';
